const isResizeObserverLoopError = (message) =>
    /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/.test(message ?? "");

const suppressEvent = (event) => {
    const message = event?.message ?? event?.error?.message ?? "";
    if (!isResizeObserverLoopError(message)) {
        return;
    }
    event.stopImmediatePropagation?.();
    event.preventDefault?.();
};

if (typeof window !== "undefined") {
    window.addEventListener("error", suppressEvent, true);

    const previousOnError = window.onerror;
    window.onerror = (message, ...rest) => {
        if (isResizeObserverLoopError(message)) {
            return true;
        }
        if (typeof previousOnError === "function") {
            return previousOnError(message, ...rest);
        }
        return false;
    };

    const previousConsoleError = window.console.error;
    window.console.error = (...args) => {
        const first = args[0];
        const message = typeof first === "string"
            ? first
            : first?.message ?? "";
        if (isResizeObserverLoopError(message)) {
            return;
        }
        previousConsoleError(...args);
    };
}
